import { z } from "zod";
import { type AudioCourseWithoutId } from "../../firestore";

export const AudioCourseServerSchema = z.object({
  slug: z.string().min(1),
});

export type AudioCourseServerQueryParams = z.infer<typeof AudioCourseServerSchema>;

export const AudioCoursesServerSchema = z.object({
  limit: z
    .string()
    .refine(
      (val) => {
        const num = Number(val);
        return Number.isInteger(num) && num >= 1 && num <= 50;
      },
      {
        message: "limit must be a string representing an integer between 1 and 50",
      },
    )
    .optional(),
  page: z
    .string()
    .refine(
      (val) => {
        const num = Number(val);
        return Number.isInteger(num) && num >= 1;
      },
      {
        message: "page must be a string representing a positive integer",
      },
    )
    .optional(),
  startAfterDateTimestamp: z.string().optional(),
  authorSlug: z.string().optional(),
  category: z.string().optional(),
});

export type AudioCoursesServerQueryParams = z.infer<typeof AudioCoursesServerSchema>;

// Transformed audio course
export type AudioCourseServerItemWithImageUrl = Omit<
  AudioCourseWithoutId,
  "date" | "created_on" | "updated_on" | "author"
> & {
  id: string;
  authorId: string;
  imageUrl: string;
  dateMillis: number;
  createdOnMillis: number;
  updatedOnMillis: number;
};

export type AudioCourseServerResponse = AudioCourseServerItemWithImageUrl;

export interface AudioCoursesServerResponse {
  courses: AudioCourseServerResponse[];
  pagination: {
    hasMore: boolean;
    startAfterDateTimestamp?: string;
    totalCount?: number;
  };
}
